<template>
<v-layout class="fill-height">
  <v-container
    id="contentDashboard" fluid
    class="fill-height"
  >
    <v-layout>
      <v-row
        align="start"
        justify="start"
      >
        <v-col cols="12" class="pt-1">
          <header-sidebar></header-sidebar>
          <v-card class="table-content">
            <v-snackbar
              v-model="snackbar"
              :color="color"
              right
              top
              app
            >
              {{snackbarText}}
              <v-btn
                text
                dark
                @click="snackbar = false"
              >
                Fermer
              </v-btn>
            </v-snackbar>
            <v-card-title>
                <v-btn text :ripple="false" depressed style="background:transparent !important;" :to="{ name: 'singleFolder', params: { id: this.$route.params.id }}" icon><v-icon>mdi-arrow-left</v-icon></v-btn> Dossier N°{{currentDossier.numdossier}} - Liste des factures
                <v-spacer></v-spacer>
                <div class="ml-2"><v-btn :to="{ name: 'singleFolder', params: { id: this.$route.params.id }}" depressed small text color="primary">Retour</v-btn></div>
                <div v-if="this.currentDossier.classe === 'Groupage'" class="ml-2"><v-btn @click="newMagasinageFacture" depressed small style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white; border-radius:25px;" >Nouvelle Facture Magasinage</v-btn></div>
                <div v-if="this.currentDossier.classe === 'Complet' && this.currentDossier.type === 'Import'" class="ml-2"><v-btn @click="newSurestarieFacture" depressed small style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white; border-radius:25px;" >Nouvelle Facture Surestarie</v-btn></div>
                <div class="ml-2"><v-btn @click="newFacture('Facture Standard')" depressed small style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white; border-radius:25px;" >Nouvelle Facture</v-btn></div>
            </v-card-title>
            <v-row>
                <v-col cols="12" md="12" class="text-left">
                    <v-simple-table>
                        <template v-slot:default>
                        <thead>
                            <tr>
                              <th class="text-left">N° Facture</th>
                              <th class="text-left">Libellé</th>
                              <th class="text-left">Date Création</th>
                              <th class="text-left">Avis N°</th>
                              <th class="text-left">Client</th>
                              <th class="text-left">Total TTC</th>
                              <th class="text-left">Réglement</th>
                              <th class="text-left">Actions</th>
                            </tr>
                        </thead>
                        <tbody v-if="factureList.length > 0">
                            <tr v-for="(facture,index) in factureList" v-bind:key="index">
                                <td>{{facture.num_facture}}</td>
                                <td>{{facture.libelle}}</td>
                                <td>{{facture.date | formatDate}}</td>
                                <td v-if="facture.num_avis !== undefined">{{facture.num_avis }}</td>
                                <td v-else>-</td>
                                <td>{{facture.client_name}} <br/> Ref.{{facture.code_client}}</td>
                                <td>{{facture.montantTotal.toFixed(3)}} TND</td>
                                <td>
                                  <div v-for="(reglement,key) in facture.reglement" v-bind:key="key">
                                    {{reglement.mode}} <span v-if="reglement.num_piece !== '' && reglement.banque !== ''">N°{{reglement.num_piece}} - {{reglement.banque}}</span> {{reglement.montant.toFixed(3)}} TND 
                                  </div>
                                </td>
                                <td>

                                    <v-icon
                                        small
                                        class="mr-2"
                                        @click="openFacture(facture)"
                                    >
                                        mdi-eye
                                    </v-icon>
                                    <v-icon
                                        small
                                        :disabled="facture.reglement.length > 0 || (facture.avis_id > 0 && facture.is_magasinage === 0 && facture.is_da === 0 && facture.is_surestarie === 0) "
                                        class="mr-2"
                                        @click.stop="editFacture(facture, facture.type)"
                                    >
                                        mdi-pencil
                                    </v-icon>
                                    <v-icon
                                        small
                                        class="mr-2"
                                        @click.stop="printFacture(facture)"
                                    >
                                        mdi-printer
                                    </v-icon>
                                    <v-icon
                                        @click.stop="deleteFacture(facture)"
                                        small
                                    >
                                        mdi-delete
                                    </v-icon>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="8" class="text-center">
                              <span>Il n'y a pas de facture dans ce dossier.</span>
                            </td>
                          </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
          </v-card>
          <v-dialog v-model="singleStandard" v-if="singleStandard">
            <single-standard-facture :factureContent="factureContent" v-on:closeSingleFactureDialog="singleStandard = false" @hide="singleStandard = false"></single-standard-facture>
          </v-dialog>
          <v-dialog v-model="createStandard" v-if="createStandard">
            <new-standard-facture :currentAvis="null" :currentDossier="currentDossier" v-on:reloadData="reloadData" v-on:hide="createStandard = false" @hide="createStandard = false"></new-standard-facture>
          </v-dialog>
          <v-dialog v-model="editStandard" v-if="editStandard">
            <edit-standard-facture :factureContent="factureContent" :dossierId="dossierId" v-on:reloadData="reloadData" @hide="editStandard = false" v-on:hideDialog="editStandard = false"></edit-standard-facture>
          </v-dialog>
          <v-dialog v-model="printStandard" fullscreen v-if="printStandard">
            <print-standard-facture :currentFacture="factureContent" v-on:hideDialog="printStandard = false" @hide="printStandard = false"></print-standard-facture>
          </v-dialog>


          <v-dialog v-model="magasinageDialog" v-if="magasinageDialog">
            <new-facture-magasinage :currentAvis="null" :currentDossier="currentDossier" v-on:reloadData="reloadData" v-on:closeFactureMagasinageDialog="closeMagasinageDialogMethod" @hide="magasinageDialog = false"></new-facture-magasinage>
          </v-dialog>
          <v-dialog v-model="magasinageSingleDialog" v-if="magasinageSingleDialog">
            <single-facture-magasinage :currentAvis="null" :factureContent="factureContent" v-on:reloadData="reloadData" v-on:closeSingleFactureDialogMethod="closeSingleFactureDialogMethod" @hide="magasinageSingleDialog = false"></single-facture-magasinage>
          </v-dialog>
          <v-dialog v-model="editMagasinage" v-if="editMagasinage">
            <edit-magasinage-facture :factureContent="factureContent" :dossierId="dossierId" v-on:reloadData="reloadData" @hide="editMagasinage = false" v-on:hideDialog="editMagasinage = false"></edit-magasinage-facture>
          </v-dialog>
          <v-dialog v-model="printMagasinage" fullscreen v-if="printMagasinage">
            <print-magasinage-facture :currentFacture="factureContent" v-on:hideDialog="printMagasinage = false" @hide="printMagasinage = false"></print-magasinage-facture>
          </v-dialog>

          <v-dialog v-model="newSurestarieDialog" v-if="newSurestarieDialog">
            <new-facture-surestarie :currentAvis="null" :currentDossier="currentDossier" v-on:reloadData="reloadData" @hide="newSurestarieDialog = false"></new-facture-surestarie>
          </v-dialog>
          <v-dialog v-model="singleSurestarie" v-if="singleSurestarie">
            <single-facture-surestarie :factureContent="factureContent" v-on:reloadData="reloadData" @hide="singleSurestarie = false"></single-facture-surestarie>
          </v-dialog>
          <v-dialog v-model="printSurestarie" fullscreen v-if="printSurestarie">
            <print-surestarie-facture :currentFacture="factureContent" v-on:hideDialog="printSurestarie = false" @hide="printSurestarie = false"></print-surestarie-facture>
          </v-dialog>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</v-layout>
</template>
<script>
import headerSidebar from '../../commons/header_sidebar.component'
import newStandardFacture from './standard/new.component.vue'
import editStandardFacture from './standard/edit.component.vue'
import printStandardFacture from './standard/print.component.vue'
import singleStandardFacture from './standard/single.component.vue'

import printMagasinageFacture from './magasinage/print.component'
import newFactureMagasinage from './magasinage/new.component'
import singleFactureMagasinage from './magasinage/single.component'
import editMagasinageFacture from './magasinage/edit.component'

import newFactureSurestarie from './surestarie/new.component'
import singleFactureSurestarie from './surestarie/single.component'
import printSurestarieFacture from './surestarie/print.component'

import singleFactureDa from './da/single.component'
import newDaFacture from './da/new.component'
import printDaFacture from './da/print.component'

export default {
  name: 'listing-facture-folder',
  data: () => ({
      dialog: false,
      currentDossier: {},
      value: '',
      newFactureDialog: false,
      factureList: [],
      factureListFinal: [],
      singleSurestarie: false,
      singleStandard : false,
      singleFactureDialog: false,
      factureContent: {},
      printDialog: false,
      montantTotal: 0,
      snackbar: false,
      snackbarText: '',
      color: "success",
      newSurestarieDialog: false,
      magasinageDialog : false,
      magasinageSingleDialog: false,
      createStandard: false,
      singleMagasinage: false,
      createDa: false,
      singleDa: false,
      createMagasinage: false,
      createSurestarie: false,
      editStandard: false,
      editDa: false,
      editMagasinage: false,
      editSurestarie: false,
      printStandard: false,
      printMagasinage: false,
      printSurestarie: false,
      
    }),
    components: {headerSidebar, newStandardFacture, singleStandardFacture, editStandardFacture, printStandardFacture, newFactureMagasinage, singleFactureMagasinage, editMagasinageFacture, printMagasinageFacture, newFactureSurestarie, singleFactureSurestarie, printSurestarieFacture, singleFactureDa, newDaFacture, printDaFacture},
    mounted() {
      this.reloadData()
    },
    methods: {
        sortFacture(factList){
          return factList.sort((a,b) => (a.num_facture > b.num_facture) ? 1 : ((b.num_facture > a.num_facture) ? -1 : 0)); 
        },
        closeSingleFactureDialogMethod(){
            this.singleFactureDialog = false
        },
        closeNewFactureDialogMethod(){
            this.newFactureDialog = false
            this.reloadData()
        },
        closePrintDialogMethod(){
          this.printDialog = false
        },
        closeMagasinageDialogMethod(){
          this.magasinageDialog = false
        },
        newMagasinageFacture(){
          this.magasinageDialog = true
        },
        newSurestarieFacture(){
          this.newSurestarieDialog = true
        },
        singleMagasinageFacture(facture){
          this.factureContent = facture 
          this.magasinageSingleDialog = true
        },
        openFacture(facture){
            this.factureContent = facture 
            if(facture.is_magasinage === 1){
              this.magasinageSingleDialog = true
            }else if(facture.is_da === 1){
              //this.singleStand = true
            }else if(facture.is_surestarie === 1){
              this.singleSurestarie = true
            }else{
              this.singleStandard = true
            }
        },
        newFacture(facture_type){
          this.newFactureType = facture_type
          if(this.newFactureType === 'Facture Magasinage'){
            this.createMagasinage = true
          }else if(this.newFactureType === 'Facture D/A'){
            this.createDa = true
          }else if(this.newFactureType === 'Facture Standard'){
            this.createStandard = true 
          }else if(this.newFactureType === 'Facture Surestarie'){
            this.createSurestarie = true
          }
          
        },
        editFacture(facture, type){
          this.factureContent = facture
          this.dossierId = facture.dossier_id
          console.log(facture.dossier_id)
          if(type === 'Facture Magasinage'){
            this.editMagasinage = true
          }else if(type === 'Facture D/A'){
            //this.editDa = true
          }else if(type === 'Facture Standard'){
            this.editStandard = true 
          }else if(type === 'Facture Surestarie'){
            this.editSurestarie = true 
          }
        },
        printFacture(facture){
          var index = this.factureList.indexOf(facture)
          this.factureList[index].loader = true
          this.axios
              .get('/facture/single/'+facture.id)
              .then(response => {
                if(response.data.client_id > 0){
                  this.axios
                      .get('/client/single/'+response.data.client_id)
                      .then(res => {
                        response.data.client = res.data
                        
                      })
                }
                this.factureContent = response.data
              }) 
          var self = this
          setTimeout(function(){
            self.factureList[index].loader = false
            if(facture.is_magasinage === 1){
              self.printMagasinage = true
            }else if(facture.is_da === 1){
              //this.singleStand = true
            }else if(facture.is_surestarie === 1){
              self.printSurestarie = true
            }else{
              self.printStandard = true
            }
          },500)
          
        },
        deleteFacture(item){
          const index = this.factureList.indexOf(item)
          if(item.reglement.length > 0){
            this.color = "error"
            this.snackbarText = "Impossible de supprimer une facture tant qu'elle contient un règlement."
            this.snackbar = true
          }else{
            if(confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?')){
              this.axios
                .delete('/facture/delete/'+item.id)
                .then(response => {
                  if(response === 'error'){
                    this.color = "error"
                    this.snackbarText = "Un erreur est survenu, essayez plus tard."
                    this.snackbar = true
                  }else{
                    this.factureList.splice(index, 1)
                    this.color = "success"
                    this.snackbarText = "La facture a été supprimée avec succès."
                    this.snackbar = true
                  }
                })
              
            }
          }
          
        },
        reloadData(){
          this.axios
            .get('/dossier/'+this.$route.params.id+'/factures')
            .then(response => {
                  response.data = this.sortFacture(response.data)
                  response.data.forEach((item, index) => {
                    if(item.is_da === 1){
                      response.data[index].type = 'Facture D/A'
                    }else if(item.is_magasinage === 1){
                      response.data[index].type = 'Facture Magasinage'
                    }else if(item.is_surestarie === 1){
                      response.data[index].type = 'Facture Surestarie'
                    }else {
                      response.data[index].type = 'Facture Standard'
                    }
                    var facture_id = item.id
                    var avis_id = item.avis_id
                    response.data[index].montantTotal = item.timbre
                    if(avis_id !== 0){
                      if(item.is_magasinage == 1 || item.is_surestarie == 1){
                        this.axios.get('/facture/single/'+facture_id)
                        .then(resFact => {
                          resFact.data.prestations.forEach((prest,ind) => {
                            response.data[index].montantTotal = response.data[index].montantTotal + prest.montant + (prest.montant * prest.tva / 100)
                          })
                        })
                      }else{
                        this.axios.get('/avis/single/'+avis_id)
                        .then(resAvis => {
                          resAvis.data.prestations.forEach((prest, ind) => {
                            response.data[index].montantTotal = response.data[index].montantTotal + prest.montant + (prest.montant * prest.tva / 100)
                          })
                        })
                      }
                    }else{
                      this.axios.get('/facture/single/'+facture_id)
                      .then(resFact => {
                        resFact.data.prestations.forEach((prest,ind) => {
                          response.data[index].montantTotal = response.data[index].montantTotal + prest.montant + (prest.montant * prest.tva / 100)
                        })
                      })
                    }
                  })
                  this.factureList = this.sortFacture(response.data)
                  console.log(this.factureList)
                })
            .catch(error => {
                this.$router.push("/dashboard/dossier")
            })
          this.axios
            .get('/dossier/single/'+this.$route.params.id)
            .then(response => {
                if(response.data.length < 1){
                  this.$router.push("/dashboard/dossier")
                }
                this.currentDossier = response.data[0]
                })
            .catch(error => {
                this.$router.push("/dashboard/dossier")
            })
          
        },
    }
  }
</script>
<style lang="scss" scoped>
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 96%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .theme--light.v-btn--active:before, .theme--light.v-btn--active:hover:before, .theme--light.v-btn:focus:before {
    opacity:0 !important;
  }
  td{
    height: 85px;
  }
</style>


// WEBPACK FOOTER //
// src/views/dashboard/dossier/facture/listing.vue